import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Boutton from '@piconetworks/pkg-boutton';

var _excluded = ["checked", "children", "className", "disabled", "inputRef", "name", "onChange", "type", "debug", "value"];
var ToggleBarItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var checked = props.checked,
    children = props.children,
    className = props.className,
    disabled = props.disabled,
    inputRef = props.inputRef,
    name = props.name,
    onChange = props.onChange,
    type = props.type,
    debug = props.debug,
    value = props.value,
    args = _objectWithoutPropertiesLoose(props, _excluded);
  if (debug) {
    console.log('ToggleBarItem: debug is true', props, args);
  }
  var classes = cx.apply(void 0, [className, 'btn-toggle'].concat(disabled && 'disabled'));
  var noop = function noop() {};
  var inputProps = Object.assign({
    checked: !!checked
  }, disabled && {
    disabled: true
  }, {
    name: name,
    onChange: onChange || noop,
    ref: inputRef,
    type: type,
    value: value
  });
  return /*#__PURE__*/React.createElement(Boutton, _extends({}, args, {
    ref: ref,
    active: !!checked,
    className: classes,
    toggle: true
  }), /*#__PURE__*/React.createElement("input", _extends({
    autoComplete: "off"
  }, inputProps)), children);
});
ToggleBarItem.displayName = 'ToggleBarItem';
ToggleBarItem.propTypes = {
  children: PropTypes.node,
  debug: PropTypes.bool,
  /**
   * The disabled state for both the button and input
   */
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
  * A ref attached to the `<input>` element
  * @type {ReactRef}
  */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
  * The HTML input name, used to group like checkboxes or radio buttons together
  * semantically
  */
  name: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.number]).isRequired
};
ToggleBarItem.defaultProps = {
  debug: false,
  disabled: false,
  type: 'radio'
};

export { ToggleBarItem as default };
//# sourceMappingURL=Item.js.map
